export enum GroupOrderPageMode {
    EDIT,
    PARTICIPANTS
}



// WEBPACK FOOTER //
// ./src/app/group-order/group-order-page/group-order-page-mode.ts